import { render } from "./TicketIssues.vue?vue&type=template&id=2da055c9"
import script from "./TicketIssues.vue?vue&type=script&lang=js"
export * from "./TicketIssues.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__